







import { Component, Vue, Prop } from 'vue-property-decorator'

@Component({})
export default class Label extends Vue {
  @Prop({ required: true, default: '' }) private id!: string
  @Prop({ required: true, default: false }) private required!: boolean
}
